import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth-service';

@Component({
    templateUrl: './sign-in.component.html'
})
export class SignInComponent implements OnInit {
    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.authService.userManager.signinRedirectCallback().then((user) => {
            const url = user.state;
            if (url) {
                window.location.href = url;
            }
        });
    }
}
